// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { info16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-info': IconInfo;
    }
}

/**
 * The icon component for the 'info' icon
 */
export class IconInfo extends Icon {
    public constructor() {
        super(info16X16);
    }
}

registerIcon('icon-info', IconInfo);
export const iconInfoTag = 'nimble-icon-info';
